import {Component} from "react";
import React from "react";

class LineContainer extends Component {

	static defaultProps = {
		lineContainerLabel: ""
	};

	render() {
		const {children, lineContainerLabel} = this.props;

		return (
			<div className={"line-container " + this.props.className} style={this.props.style}>
				<div className="line-container-label">{lineContainerLabel}</div>
				{children}
			</div>
		);
	}
}

export default LineContainer;
